import { Flex, Tooltip, Typography } from "antd";

import Button from "../../../../../Components/Button";

const { Text } = Typography;

const BulkActionsToolbar = ({
  t,
  selectedCount,
  changeStatusDisabled,
  isSameProvider,
  onOpenModal,
  onCancel,
}) => {
  const changeStatusTooltip = !isSameProvider
    ? t(
        "Bulk status updates are available only for enrollment requests from the same Alert Provider."
      )
    : "";

  return (
    <Flex gap={16} align="center" justify="space-between" style={{ margin: "0 0 20px" }}>
      <Flex gap={16} align="center">
        <Text type="secondary" style={{ flexShrink: 0 }}>
          {t("Bulk action")}
        </Text>
        <Tooltip
          title={changeStatusTooltip}
          overlayInnerStyle={{ width: 290, maxWidth: 290, textAlign: "center" }}
        >
          <span style={{ display: "inline-block" }}>
            <Button disabled={changeStatusDisabled} onClick={onOpenModal}>
              {t("Change enrollment status for _amount_ selected requests", {
                amount: selectedCount,
              })}
            </Button>
          </span>
        </Tooltip>
      </Flex>

      <Button style={{ flexShrink: 0 }} onClick={onCancel}>
        {t("Cancel bulk action")}
      </Button>
    </Flex>
  );
};

export default BulkActionsToolbar;
